import { AlertTriangle } from "lucide-react";
import { Trans, useTranslation } from "react-i18next";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

interface CustomerLimitationBannerProps {
  isLimited: boolean;
  customerCount: number;
  onUpgrade?: () => void;
  onDismiss?: () => void;
}

export function CustomerLimitationBanner({
  isLimited,
  customerCount: _customerCount,
  onUpgrade,
  onDismiss,
}: CustomerLimitationBannerProps) {
  const { t } = useTranslation("common");

  if (!isLimited) return null;

  const _handleUpgrade = () => {
    onUpgrade?.();
  };

  const _handleDismiss = () => {
    onDismiss?.();
  };

  return (
    <Alert className="mb-4 border-amber-200 bg-amber-50 relative">
      <AlertTriangle className="h-4 w-4 text-amber-600" />
      <AlertTitle className="text-amber-800 pr-8">
        {t("premium.banners.limitedCustomers.title")}
      </AlertTitle>
      <AlertDescription className="text-amber-700">
        <Trans
          i18nKey="premium.banners.limitedCustomers.description"
          ns="common"
          components={{ strong: <strong /> }}
        />
      </AlertDescription>
    </Alert>
  );
}
